export enum ConditionsConfirmationGenerationStatus {
    ReadyToGenerate = 1,
    AlreadyGenerated = 2,
    CannotGenerateForMandateAgreement = 3,
    CannotGenerateForImportedFromOtherSystems = 4,
    CannotGenerateForNotSignByUser = 5
}